import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminActivityManager.css";

const AdminActivityManager = () => {

const [activities,setActivities] = useState([]);
const [filtered,setFiltered] = useState([]);
const [editing,setEditing] = useState(null);

const [search,setSearch] = useState("");

const [page,setPage] = useState(1);
const perPage = 8;

const [form,setForm] = useState({
evtitle:"",
evdate:"",
category:"Academic",
evremark:""
});

const [image,setImage] = useState(null);
const [preview,setPreview] = useState(null);



/* FETCH */

useEffect(()=>{
fetchActivities();
},[]);


const fetchActivities = async()=>{

const res = await axios.get(
"/api/activities"
);

setActivities(res.data);
setFiltered(res.data);

};



/* SEARCH */

useEffect(()=>{

const result = activities.filter(a =>
a.evtitle.toLowerCase().includes(search.toLowerCase()) ||
a.category.toLowerCase().includes(search.toLowerCase())
);

setFiltered(result);

},[search,activities]);



/* FORM */

const handleChange = e=>{
setForm({...form,[e.target.name]:e.target.value});
};



/* IMAGE UPLOAD */

const handleImage = e=>{

const file = e.target.files[0];

setImage(file);

if(file){
setPreview(URL.createObjectURL(file));
}

};



/* DRAG DROP */

const handleDrop = e=>{
e.preventDefault();

const file = e.dataTransfer.files[0];

setImage(file);
setPreview(URL.createObjectURL(file));
};



const handleDragOver = e=>{
e.preventDefault();
};



/* SUBMIT */

const handleSubmit = async e=>{

e.preventDefault();

const formData = new FormData();

formData.append("evtitle",form.evtitle);
formData.append("evdate",form.evdate);
formData.append("category",form.category);
formData.append("evremark",form.evremark);

if(image){
formData.append("imgpic",image);
}

if(editing){

formData.append("oldImage",editing.imgpic);

await axios.put(
`/api/activities/update/${editing.id}`,
formData
);

}else{

await axios.post(
"/api/activities/add",
formData
);

}

resetForm();
fetchActivities();

};



/* RESET */

const resetForm = ()=>{

setEditing(null);

setForm({
evtitle:"",
evdate:"",
category:"Academic",
evremark:""
});

setPreview(null);
setImage(null);

};



/* EDIT */

const editActivity = a=>{

setEditing(a);
setForm(a);
window.scrollTo({ top: 0, behavior: "smooth" });
};



/* DELETE */

const deleteActivity = async id=>{

if(!window.confirm("Delete this activity?")) return;

await axios.delete(
`/api/activities/delete/${id}`
);

fetchActivities();

};



/* PAGINATION */

const last = page * perPage;
const first = last - perPage;
const current = filtered.slice(first,last);

const totalPages = Math.ceil(filtered.length / perPage);



return(

<div className="activity-admin">

<div className="activity-header">

<h2>Activity Manager</h2>

<input
className="search-box"
placeholder="Search activity..."
value={search}
onChange={e=>setSearch(e.target.value)}
/>

</div>



<form className="activity-form" onSubmit={handleSubmit}>

<input
name="evtitle"
placeholder="Activity Title"
value={form.evtitle}
onChange={handleChange}
required
/>

<input
type="date"
name="evdate"
value={form.evdate}
onChange={handleChange}
required
/>

<select
name="category"
value={form.category}
onChange={handleChange}
>

<option>National Event</option>
<option>Festival</option>
<option>Function</option>
<option>Sports</option>
<option>School</option>
<option>Class</option>
<option>Laboratory</option>
<option>Library</option>
<option>Computer</option>
<option>Competition</option>
<option>Seminar</option>
<option>Workshop</option>
<option>Social Activity</option>
<option>Farewell</option>
<option>Party</option>
<option>Tour</option>
<option>Academic</option>
<option>Cultural</option>
<option>Advertisement</option>
<option>Others</option>

</select>


<textarea
name="evremark"
placeholder="Activity Description"
value={form.evremark}
onChange={handleChange}
/>


<div
className="drop-zone"
onDrop={handleDrop}
onDragOver={handleDragOver}
>

Drag & Drop Image Here

<input type="file" onChange={handleImage}/>

</div>


{preview && (
<img
src={preview}
className="preview-img"
alt=""
/>
)}


<button className="save-btn">
{editing ? "Update Activity" : "Add Activity"}
</button>

</form>



<table className="activity-table">

<thead>

<tr>
<th>ID</th>
<th>Image</th>
<th>Title</th>
<th>Date</th>
<th>Category</th>
<th>Description</th>
<th>Action</th>
</tr>

</thead>

<tbody>

{current.map(a=>(
<tr key={a.id}>

<td>{a.id}</td>

<td>
<img
src={`${BASE_URL}/uploads/activities/${a.imgpic}`}
className="grid-img"
alt=""
/>
</td>

<td>{a.evtitle}</td>
<td>{a.evdate}</td>
<td>{a.category}</td>
<td className="desc">{a.evremark}</td>

<td>

<button
className="edit-btn"
onClick={()=>editActivity(a)}
>
Edit
</button>

<button
className="delete-btn"
onClick={()=>deleteActivity(a.id)}
>
Delete
</button>

</td>

</tr>
))}

</tbody>

</table>



<div className="pagination">

{Array.from({length:totalPages},(_,i)=>(
<button
key={i}
className={page===i+1?"active":""}
onClick={()=>setPage(i+1)}
>
{i+1}
</button>
))}

</div>

</div>

);

};

export default AdminActivityManager;